/* eslint-disable capitalized-comments */
import { http, HttpResponse } from 'msw'

import { allMachineRelations } from 'app/mocks/data/machines/machineRelations'

import { api, queryIntoArrayNumber } from 'app/utils/constants'
import { getProductsFormattedMachineRelation } from 'app/utils/reports/stock/mocks'

export const getStock = http.get(
    `${process.env.REACT_APP_API_ADDRESS}/${api.reports.STOCK}`,
    ({ request }) => {
        const { searchParams } = new URL(request.url)
        // const clientIdsFilter = searchParams.get('clients')
        // const siteIdsFilter = searchParams.get('sites')
        const terminlIdsFilter = searchParams.get('terminals')

        let allMachineRelationsFiltered = allMachineRelations

        // TODO: Get the client ID
        // // Client filter
        // if (!!clientIdsFilter) {
        //     const clientIdsSplit = clientIdsFilter.split(',')

        //     allMachineRelationsFiltered = allMachineRelationsFiltered.filter((machineRelation) =>
        //         clientIdsSplit.includes(machineRelation.client.id.toString()),
        //     )
        // }

        // TODO: Get the site ID
        // // Site filter
        // if (!!siteIdsFilter) {
        //     const siteIdsSplit = siteIdsFilter.split(',')

        //     allMachineRelationsFiltered = allMachineRelationsFiltered.filter((machineRelation) =>
        //         siteIdsSplit.includes(machineRelation.client.id.toString()),
        //     )
        // }

        // Terminal filter
        if (terminlIdsFilter) {
            const terminalIdsSplit = queryIntoArrayNumber(terminlIdsFilter)

            allMachineRelationsFiltered = allMachineRelationsFiltered.filter(
                (machineRelation) =>
                    terminalIdsSplit.includes(machineRelation.machine.id),
            )
        }

        const terminalsFormatted = []

        // Get the terminals formatted
        for (const machineRelation of allMachineRelationsFiltered) {
            const terminalFormatted =
                getProductsFormattedMachineRelation(machineRelation)

            terminalsFormatted.push(terminalFormatted)
        }

        // TODO: Get the right manager, client and site
        const stock = {
            manager: {
                id: 1,
                name: 'Manager1',
                clients: [
                    {
                        id: 1,
                        name: 'Client1',
                        sites: [
                            {
                                id: 1,
                                name: 'Site1',
                                terminals: terminalsFormatted,
                            },
                            {
                                id: 2,
                                name: 'Site2',
                                terminals: terminalsFormatted,
                            },
                            {
                                id: 3,
                                name: 'Site3',
                                terminals: terminalsFormatted,
                            },
                        ],
                    },
                    {
                        id: 2,
                        name: 'Client2',
                        sites: [
                            {
                                id: 1,
                                name: 'Site1',
                                terminals: terminalsFormatted,
                            },
                            {
                                id: 2,
                                name: 'Site2',
                                terminals: terminalsFormatted,
                            },
                            {
                                id: 3,
                                name: 'Site3',
                                terminals: terminalsFormatted,
                            },
                        ],
                    },
                    {
                        id: 3,
                        name: 'Client3',
                        sites: [
                            {
                                id: 1,
                                name: 'Site1',
                                terminals: terminalsFormatted,
                            },
                            {
                                id: 2,
                                name: 'Site2',
                                terminals: terminalsFormatted,
                            },
                            {
                                id: 3,
                                name: 'Site3',
                                terminals: terminalsFormatted,
                            },
                        ],
                    },
                ],
            },
        }

        const stockResponse = terminalsFormatted.length > 0 ? stock : undefined

        return HttpResponse.json(stockResponse)
    },
)
